import React from 'react';
import {NumberInput, TextInput} from 'react-admin';
import {useTranslation} from 'react-i18next';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import Filter1Icon from '@material-ui/icons/Filter1';
import EventIcon from '@material-ui/icons/Event';

const iconFor = (type) => {
    switch (type) {
        case 'numeric':
            return Filter1Icon;
        case 'date':
            return EventIcon;
        default:
            return TextFieldsIcon;
    }
};

const AttributeInput = ({attribute}) => {
    const {t} = useTranslation();
    const source = `attribute_${attribute.id}`;
    const Icon = iconFor(attribute.type);
    const typeKey = `attribute.type.${attribute.type || 'string'}`;

    const label = (
        <span style={{display: 'inline-flex', alignItems: 'center', gap: 4}}>
            <Icon fontSize="small" color="action" titleAccess={t(typeKey)}/>
            {attribute.name}
        </span>
    );

    switch (attribute.type) {
        case 'numeric':
            return <NumberInput fullWidth label={label} source={source}/>;
        case 'date':
            return <TextInput fullWidth label={label} source={source}
                              type="date" InputLabelProps={{shrink: true}}/>;
        default:
            return <TextInput fullWidth label={label} source={source}/>;
    }
};

export default AttributeInput;
